"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowCardStep = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var FlowCardStep = function (_a) {
    var orderNumber = _a.orderNumber, headerIcon = _a.headerIcon, title = _a.title, headerAction = _a.headerAction, content = _a.content, footerAction = _a.footerAction, error = _a.error, saved = _a.saved, active = _a.active, className = _a.className, disabled = _a.disabled, style = _a.style;
    var statusIcon = classnames_1.default('FlowCardStep__status', {
        'FlowCardStep__status--error': error && !headerIcon,
        'FlowCardStep__status--active': active && !disabled && !headerIcon,
        'FlowCardStep__status--saved': !active && saved && !headerIcon,
    });
    var cardState = classnames_1.default('FlowCardStep', className, {
        'FlowCardStep--error': error,
        'FlowCardStep--active': active && !disabled,
        'FlowCardStep--saved': !active && saved,
        'FlowCardStep--ordered': orderNumber !== undefined,
        'FlowCardStep--headerOnly': !content,
    });
    var FlowCardStepStatus = function () {
        if (error) {
            return react_1.default.createElement(__1.Icon, { name: "warning", size: "18px", className: "c-red-400" });
        }
        if (orderNumber !== undefined && orderNumber !== false) {
            if (saved && !active) {
                return (react_1.default.createElement(__1.Icon, { name: "check_circle", size: "24px", className: "c-green-400" }));
            }
            return orderNumber;
        }
        if (active && !disabled)
            return react_1.default.createElement(__1.Icon, { name: "edit", size: "14px", className: "c-white" });
        if (saved) {
            return (react_1.default.createElement(__1.Icon, { name: "check_circle", size: "24px", className: "c-green-400" }));
        }
        return (react_1.default.createElement(__1.Icon, { name: "check_circle", size: "24px", className: "c-neutral-70" }));
    };
    return (react_1.default.createElement(__1.Card, { className: cardState, disabled: disabled, style: style },
        react_1.default.createElement(__1.Card.Section, { className: "FlowCardStep__header" },
            react_1.default.createElement("div", { className: "d-f align-items-center" },
                react_1.default.createElement("span", { className: "FlowCardStep__statusWrapper" }, headerIcon ? (headerIcon) : (react_1.default.createElement("span", { className: statusIcon }, FlowCardStepStatus()))),
                react_1.default.createElement(__1.Headline, { className: "m-b-0 d-f align-items-end" }, title)),
            headerAction && headerAction),
        content && react_1.default.createElement(__1.Card.Section, null, content),
        footerAction && (react_1.default.createElement(__1.Card.Section, { className: "FlowCardStep__footer" }, footerAction))));
};
exports.FlowCardStep = FlowCardStep;
//# sourceMappingURL=FlowCardStep.js.map